import React from "react";
import { FaBoxOpen } from "react-icons/fa";
import { MdCollections } from "react-icons/md";

const InventoryOption = ({ inventory, setOption }) => {
  return (
    <div className="inventory-option">
      <h2>Inventory</h2>
      <ul>
        <div onClick={() => setOption("collections")} className="">
          <li>
            <MdCollections /> Collections
          </li>
        </div>
        <div onClick={() => setOption("products")} className="collection-flex">
          <li>
            <FaBoxOpen /> Products
          </li>
          <p> {inventory.length}</p>
        </div>
      </ul>
    </div>
  );
};

export default InventoryOption;
